import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { Angulartics2Module } from 'angulartics2';
import { ScanGMailButtonComponent } from './components/scan-gmail-button/scan-gmail-button.component';
import { SharedModule } from '../shared.module';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatIconModule,
        RouterModule,
        Angulartics2Module,
        SharedModule
     ],
    declarations: [
        ScanGMailButtonComponent,
    ],
    exports: [
        ScanGMailButtonComponent,
    ]
})
export class ScanGMailButtonModule {}